module.exports = __webpack_public_path__ + "static/media/bottles_scrolling.1491e634.png";